import { Div, P, Td, Tooltip, Tr } from '@dnb/eufemia';
import { Field, Form, Value } from '@dnb/eufemia/extensions/forms';
import styled from '@emotion/styled';

const TdWithHiddenStatus = styled(Td)`
  .dnb-forms-field-block__status {
    display: none;
  }
`;

const InlineFieldWrapper = styled(Div)`
  display: inline-block;
`;

type ScopeEnvSelectItemProps = {
  itemIndex: number;
  liveAccessEnabled: boolean;
};

export default function ScopeEnvSelectItem({ itemIndex, liveAccessEnabled }: ScopeEnvSelectItemProps) {
  const { update } = Form.useData();

  const testScopeChanged = (value: boolean) => {
    if (!value) {
      update(`/scopes/${itemIndex}/live`, false);
    }
  };
  const liveScopeChanged = (value: boolean) => {
    if (value) {
      update(`/scopes/${itemIndex}/test`, true);
    }
  };
  return (
    <Tr>
      <Td>
        <P style={{ margin: 0 }} weight="medium">
          <Value.String itemPath="/name" />
        </P>
        <P style={{ margin: 0 }}>
          <Value.String itemPath="/description" />
        </P>
      </Td>
      <TdWithHiddenStatus>
        <Field.Boolean itemPath="/test" label="" onChange={(val) => testScopeChanged(val as boolean)} />
      </TdWithHiddenStatus>
      <TdWithHiddenStatus>
        {liveAccessEnabled ? (
          <Field.Boolean itemPath="/live" label="" onChange={(val) => liveScopeChanged(val as boolean)} />
        ) : (
          <Tooltip
            targetElement={
              <InlineFieldWrapper>
                <Field.Boolean disabled itemPath="/live" label="" />
              </InlineFieldWrapper>
            }
          >
            Live access is not enabled.
          </Tooltip>
        )}
      </TdWithHiddenStatus>
    </Tr>
  );
}
